var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0275B6",
    fillRule: "evenodd",
    stroke: "#07B",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.69 8.121c-.192-3.3-2.913-5.938-6.193-5.938-1.99 0-3.918.977-5.113 2.57-.027-.014-.056-.024-.084-.037a3.161 3.161 0 0 0-.574-.215 3.277 3.277 0 0 0-.378-.078c-.038-.006-.074-.014-.112-.018a3.304 3.304 0 0 0-3.67 3.278c0 .048.003.094.007.14C2.048 8.654 1 10.396 1 12.14a4.715 4.715 0 0 0 4.71 4.71H7.6a.367.367 0 1 0 0-.733H5.71a3.981 3.981 0 0 1-3.977-3.977c0-1.523.992-3.104 2.359-3.76l.208-.099V8.05c0-.045.003-.091.006-.138l.003-.064-.005-.069c-.001-.032-.004-.063-.004-.096a2.57 2.57 0 0 1 2.567-2.566c.113 0 .225.01.336.024l.085.013c.098.017.195.038.29.065l.038.01c.105.032.207.072.307.118l.075.036a2.565 2.565 0 0 1 1.435 2.3.367.367 0 1 0 .734 0c0-1.01-.457-1.913-1.174-2.519 1.051-1.375 2.783-2.247 4.504-2.247 2.84 0 5.2 2.25 5.445 5.092a6.982 6.982 0 0 0-1.497.045.367.367 0 1 0 .11.725c.815-.123 1.666-.007 1.717 0 1.708.324 2.995 1.897 2.995 3.66a3.681 3.681 0 0 1-3.677 3.678h-1.457a.367.367 0 1 0 0 .733h1.457A4.415 4.415 0 0 0 23 12.44c0-2.013-1.403-3.818-3.31-4.319z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.626 11.824a.367.367 0 0 0-.52 0l-2.932 2.933a.366.366 0 1 0 .519.519L12 12.968v7.549a.367.367 0 1 0 .733 0v-7.549l2.308 2.308a.366.366 0 0 0 .518 0 .366.366 0 0 0 0-.519l-2.933-2.933z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d37e0dd06655476dc2c2ece3002c2971.svg";
export { ForwardRef as ReactComponent };